import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/negative-binomial/cdf';
import __var_2__ from '@stdlib/stats/base/dists/negative-binomial/ctor';
import __var_3__ from '@stdlib/stats/base/dists/negative-binomial/kurtosis';
import __var_4__ from '@stdlib/stats/base/dists/negative-binomial/logpmf';
import __var_5__ from '@stdlib/stats/base/dists/negative-binomial/mean';
import __var_6__ from '@stdlib/stats/base/dists/negative-binomial/mgf';
import __var_7__ from '@stdlib/stats/base/dists/negative-binomial/mode';
import __var_8__ from '@stdlib/stats/base/dists/negative-binomial/pmf';
import __var_9__ from '@stdlib/stats/base/dists/negative-binomial/quantile';
import __var_10__ from '@stdlib/stats/base/dists/negative-binomial/skewness';
import __var_11__ from '@stdlib/stats/base/dists/negative-binomial/stdev';
import __var_12__ from '@stdlib/stats/base/dists/negative-binomial/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace negativeBinomial
*/
var negativeBinomial = {};

/**
* @name cdf
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/cdf}
*/
setReadOnly( negativeBinomial, 'cdf', __var_1__);

/**
* @name NegativeBinomial
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/ctor}
*/
setReadOnly( negativeBinomial, 'NegativeBinomial', __var_2__);

/**
* @name kurtosis
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/kurtosis}
*/
setReadOnly( negativeBinomial, 'kurtosis', __var_3__);

/**
* @name logpmf
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/logpmf}
*/
setReadOnly( negativeBinomial, 'logpmf', __var_4__);

/**
* @name mean
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/mean}
*/
setReadOnly( negativeBinomial, 'mean', __var_5__);

/**
* @name mgf
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/mgf}
*/
setReadOnly( negativeBinomial, 'mgf', __var_6__);

/**
* @name mode
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/mode}
*/
setReadOnly( negativeBinomial, 'mode', __var_7__);

/**
* @name pmf
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/pmf}
*/
setReadOnly( negativeBinomial, 'pmf', __var_8__);

/**
* @name quantile
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/quantile}
*/
setReadOnly( negativeBinomial, 'quantile', __var_9__);

/**
* @name skewness
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/skewness}
*/
setReadOnly( negativeBinomial, 'skewness', __var_10__);

/**
* @name stdev
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/stdev}
*/
setReadOnly( negativeBinomial, 'stdev', __var_11__);

/**
* @name variance
* @memberof negativeBinomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/negative-binomial/variance}
*/
setReadOnly( negativeBinomial, 'variance', __var_12__);


// EXPORTS //
export default negativeBinomial;

export { __var_1__ as cdf, __var_2__ as NegativeBinomial, __var_3__ as kurtosis, __var_4__ as logpmf, __var_5__ as mean, __var_6__ as mgf, __var_7__ as mode, __var_8__ as pmf, __var_9__ as quantile, __var_10__ as skewness, __var_11__ as stdev, __var_12__ as variance};